<template>
  <PropertyOnboardingStep title="Are pets allowed in your property?" :submit="submit">
    <PropertyPetPolicyForm ref="formRef" />
  </PropertyOnboardingStep>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { PropertyPetPolicyForm } from '@tallo/investor/property';

import PropertyOnboardingStep from '../property-onboarding-step.vue';

const formRef = ref<InstanceType<typeof PropertyPetPolicyForm>>();

async function submit() {
  await formRef.value?.save();
}
</script>
